import { notification } from 'antd';
import codeMessage from './codeMessage';

// Pull a human-readable message out of a response body, tolerating the several
// shapes the backend uses. Mirrors errorHandler so success and error toasts read
// the same keys: a plain `message`, a FastAPI `detail` array of `{ msg }`, a
// `detail` string, or a bare string body. Falls back to the status code's
// generic text when the body carries no message.
const extractMessage = (data, status) => {
  if (typeof data === 'string' && data.trim()) return data;
  if (data?.message) return data.message;
  if (Array.isArray(data?.detail)) {
    return data.detail.map((d) => d?.msg ?? d).join('\n');
  }
  if (typeof data?.detail === 'string') return data.detail;
  return codeMessage[status];
};

const successHandler = (
  response,
  options = {
    notifyOnSuccess: false,
    notifyOnFailed: true
  },
  successTitle = 'Success'
) => {
  // Callers pass `{ response, status }` where `response` is the axios response,
  // so the payload lives at `response.response.data`. Fall back to a flat
  // `response.data` in case a caller passes the axios response directly.
  const { status } = response;
  const data = response.response?.data ?? response.data;
  // Check for success status codes
  if (status >= 200 && status < 300) {
    const successText = extractMessage(data, status);
    if (options.notifyOnSuccess) {
      notification.config({
        duration: 5,
        maxCount: 5
      });
      notification.success({
        message: successTitle,
        description: successText
      });
    }
  } else {
    // For non-success status codes, treat it as an error notification
    const errorText = extractMessage(data, status);
    if (options.notifyOnFailed) {
      notification.config({
        duration: 4,
        maxCount: 2
      });
      notification.error({
        message: `Request error ${status}`,
        description: errorText
      });
    }
  }
};

export default successHandler;
